import React from 'react';
import { Helmet } from 'react-helmet-async';
import { PlaneIcon, UsersIcon, PackageIcon, RadioIcon, SparklesIcon, CrownIcon } from 'lucide-react';
export function ServicesPage() {
  const services = [{
    icon: PlaneIcon,
    title: 'Ramp Handling',
    description: 'Layanan lengkap di apron termasuk marshalling, pushback, towing, dan chocking untuk memastikan pergerakan pesawat yang aman dan efisien.',
    image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80'
  }, {
    icon: UsersIcon,
    title: 'Passenger Service',
    description: 'Pelayanan penumpang dari check-in, boarding, hingga baggage handling dengan fokus pada kenyamanan dan kepuasan pelanggan.',
    image: 'https://images.unsplash.com/photo-1556388158-158ea5ccacbd?w=800&q=80'
  }, {
    icon: PackageIcon,
    title: 'Cargo Handling',
    description: 'Penanganan kargo dan bagasi dengan sistem tracking modern, memastikan barang sampai dengan aman dan tepat waktu.',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80'
  }, {
    icon: RadioIcon,
    title: 'Flight Support & Coordination',
    description: 'Koordinasi operasional penerbangan termasuk flight planning, weather briefing, dan komunikasi dengan tower control.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/42MWA9WVp489VG2zz5hUrj/IMG-20251022-WA0014.jpg'
  }, {
    icon: SparklesIcon,
    title: 'Cabin Cleaning',
    description: 'Layanan pembersihan kabin pesawat yang menyeluruh dengan standar kebersihan tinggi untuk kenyamanan penumpang.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ivxUs6CSTa57ABNhUgX2JV/IMG-20251022-WA0008.jpg'
  }, {
    icon: CrownIcon,
    title: 'VIP Protocol Service',
    description: 'Layanan protokol khusus untuk penumpang VIP dengan handling eksklusif dan perhatian detail yang maksimal.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1tiyj5ecZESgoRWbCMY5wG/IMG-20251022-WA0007.jpg'
  }];
  return <div className="w-full" data-id="element-432">
      <Helmet data-id="element-433">
        <title data-id="element-434">
          Layanan Ground Handling - PT Jagat Indo Perkasa | Ramp, Passenger,
          Cargo, Flight Support
        </title>
        <meta name="description" content="Layanan ground handling komprehensif dari PT Jagat Indo Perkasa: Ramp Handling profesional, Passenger Service berkelas, Cargo Handling aman, Flight Support & Coordination, Cabin Cleaning standar tinggi, dan VIP Protocol Service eksklusif. Tim profesional dengan peralatan modern dan standar internasional IATA & ICAO tersedia 24/7." data-id="element-435" />
        <meta name="keywords" content="layanan ground handling Indonesia, ramp handling profesional, passenger service bandara, cargo handling aman, flight support coordination, cabin cleaning pesawat, VIP protocol service, ground handling 24/7, marshalling pesawat, pushback towing, baggage handling, check-in boarding" data-id="element-436" />
        <meta name="author" content="PT Jagat Indo Perkasa" data-id="element-437" />
        <meta name="robots" content="index, follow" data-id="element-438" />
        <link rel="canonical" href="https://jagatindoperkasa.id/services" data-id="element-439" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" data-id="element-440" />
        <meta property="og:url" content="https://jagatindoperkasa.id/services" data-id="element-441" />
        <meta property="og:site_name" content="PT Jagat Indo Perkasa" data-id="element-442" />
        <meta property="og:title" content="Layanan Ground Handling Profesional - PT Jagat Indo Perkasa" data-id="element-443" />
        <meta property="og:description" content="Solusi ground handling komprehensif untuk setiap kebutuhan operasional penerbangan dengan standar internasional IATA & ICAO. Layanan 24/7 di 4 bandara strategis Indonesia." data-id="element-444" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-445" />
        <meta property="og:locale" content="id_ID" data-id="element-446" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-447" />
        <meta name="twitter:url" content="https://jagatindoperkasa.id/services" data-id="element-448" />
        <meta name="twitter:title" content="Layanan Ground Handling - PT Jagat Indo Perkasa" data-id="element-449" />
        <meta name="twitter:description" content="Solusi ground handling komprehensif dengan standar internasional. Ramp, Passenger, Cargo, Flight Support, Cabin Cleaning, VIP Service 24/7." data-id="element-450" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" data-id="element-451" />
        <script type="application/ld+json" data-id="element-452">
          {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Service',
          '@id': 'https://jagatindoperkasa.id/services#service',
          serviceType: 'Ground Handling Services',
          provider: {
            '@type': 'Organization',
            '@id': 'https://jagatindoperkasa.id/#organization'
          },
          areaServed: {
            '@type': 'Country',
            name: 'Indonesia'
          },
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Ground Handling Services',
            itemListElement: services.map((service, index) => ({
              '@type': 'Offer',
              position: index + 1,
              itemOffered: {
                '@type': 'Service',
                name: service.title,
                description: service.description
              }
            }))
          }
        })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-500 to-blue-700 text-white py-16" data-id="element-453">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-455">Layanan Kami</h1>
          <p className="text-xl text-sky-100" data-id="element-456">
            Solusi ground handling komprehensif untuk setiap kebutuhan
            operasional penerbangan
          </p>
        </div>
      </section>
      {/* Services Grid */}
      <section className="py-16 bg-white" data-id="element-457">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-458">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-459">
            {services.map((service, index) => <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group" data-id="element-460">
                <div className="relative h-48 overflow-hidden" data-id="element-461">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" data-id="element-462" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-463"></div>
                  <div className="absolute bottom-4 left-4" data-id="element-464">
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center" data-id="element-465">
                      <service.icon className="w-6 h-6 text-sky-600" data-id="element-466" />
                    </div>
                  </div>
                </div>
                <div className="p-6" data-id="element-467">
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-468">
                    {service.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-469">{service.description}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50" data-id="element-470">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-471">
          <div className="text-center mb-12" data-id="element-472">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-473">
              Mengapa Memilih Kami?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-474">
              Keunggulan yang membedakan kami dari kompetitor
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-475">
            {[{
            title: 'Tim Profesional',
            description: 'Crew terlatih dan bersertifikat'
          }, {
            title: 'Peralatan Modern',
            description: 'Ground support equipment terkini'
          }, {
            title: 'Standar Internasional',
            description: 'Mengikuti regulasi IATA & ICAO'
          }, {
            title: 'Layanan 24/7',
            description: 'Siap melayani kapan saja'
          }].map((item, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-sm text-center" data-id="element-476">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-477">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-478">{item.description}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}